import { graphql } from "@apollo/client/react/hoc"
import produce from "immer"
import compose from "lodash/flowRight"
import {
  CreateRegistrationUpsertGroupDocument,
  PathDocument
} from "../../api/generated"
import { withContextAsProp } from "../../utils/component"
import ResourceContext from "../ResourceContext"
import withPathQueryVariables from "../graphql/withPathQueryVariables"

export default compose(
  withPathQueryVariables,
  withContextAsProp(ResourceContext, "parentGroupId", "group.id"),
  graphql(CreateRegistrationUpsertGroupDocument, {
    props: ({ mutate, ownProps }) => ({
      createRegistrationUpsertGroup: (createrRegistration) =>
        mutate({
          variables: {
            createrRegistration,
            resource_id: ownProps.pathItem.linked_resource.id,
            parent_offering_id: ownProps.parentGroupId,
            step_source_id: ownProps.pathItem.source_id
          },
          update: (cache, result) => {
            const query = PathDocument
            // Don't need PathItem.blocks because this not an editable Path
            const variables = ownProps.pathQueryVariables
            const data = cache.readQuery({ query, variables })
            const nextData = produce(data, (draft) => {
              const edge = draft.path.items.edges.find(
                (edge) => edge.node.id === ownProps.pathItem.id
              )
              edge.node.linked_cohort =
                result.data.createRegistrationUpsertGroup

              if (draft.path.user) {
                edge.node.linked_registration =
                  result.data.createRegistrationUpsertGroup.user_registration
              }
            })

            cache.writeQuery({ query, variables, data: nextData })
          }
        })
    })
  })
)
